import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import longGrid, { Types as TypesLongGrid } from '@/app/shared/store/modules/LongGrid'

const NAMESPACE = 'dailySales/dailySalesDetail/'

const builDailySalesDefaultParameters = (date) => {
  return {
    factTableName: 'dw_daily_sales_v2',
    metrics: {
      normal: ['quantity_sold', 'real_sales_cost', 'real_sales_amount'],
      var: []
    },
    dateFilters: {
      date: {
        operator: 'BT',
        value: [date, date]
      }
    }
  }
}

const _types = {
  getters: {
    BASE_DIMENSION: 'BASE_DIMENSION',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS',
    PIVOTED_FILTER_DIMENSION_IDS: 'PIVOTED_FILTER_DIMENSION_IDS'
  },
  actions: {
    INIT: 'INIT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const DailySalesDetail = {
  namespaced: true,
  state: {
    retailId: null
  },
  getters: {
    [_types.getters.BASE_DIMENSION]: (state, getters) => {
      return getters[TypesLongGrid.getters.BASE_DIMENSION]
    },
    [_types.getters.PIVOT_DIMENSIONS]: (state, getters) => {
      return getters[TypesLongGrid.getters.PIVOT_DIMENSIONS]
    },
    [_types.getters.PIVOTED_FILTER_DIMENSION_IDS]: (state, getters) => {
      return ['retail_id', ...getters[TypesLongGrid.getters.PIVOTED_FILTER_DIMENSION_IDS]]
    }
  },
  actions: {
    async [_types.actions.INIT] ({ dispatch, rootState }, { date, retailId }) {
      const { dimensions, filters } = rootState.dailySales
      const selectedStoreFilters = { ...filters.selectedStoreFilters, retail_id: [retailId] }
      const defaultDimension = dimensions.find(dimension => dimension.id === 'vendor_product')
      const dailySalesDefaultParameters = builDailySalesDefaultParameters(date)
      await dispatch(TypesLongGrid.actions.INIT, {
        dimensions,
        defaultDimension,
        filters: { selectedStoreFilters, selectedProductFilters: filters.selectedProductFilters },
        defaultParameters: dailySalesDefaultParameters
      })
    },
    async [_types.actions.APPLY_FILTERS] ({ dispatch }, { storeFilters, productFilters }) {
      await dispatch(TypesLongGrid.actions.APPLY_FILTERS, { storeFilters, productFilters })
    },
    async [_types.actions.CHANGE_BASE_DIMENSION] ({ dispatch }, dimensionId) {
      await dispatch(TypesLongGrid.actions.CHANGE_BASE_DIMENSION, dimensionId)
    },
    async [_types.actions.CHANGE_PIVOT] ({ dispatch, rootState }, { params, option }) {
      await dispatch(TypesLongGrid.actions.CHANGE_PIVOT, { params, option })
    },
    async [_types.actions.POP_UNTIL_BREADCRUMB] ({ dispatch }, breadCrumbItem) {
      await dispatch(TypesLongGrid.actions.POP_UNTIL_BREADCRUMB, breadCrumbItem)
    },
    [_types.actions.DOWNLOAD_GRID_TO_EXCEL] ({ dispatch }) {
      dispatch(TypesLongGrid.actions.DOWNLOAD_GRID_TO_EXCEL)
    },
    [_types.actions.RESET] ({ dispatch }) {
      dispatch(TypesLongGrid.actions.RESET)
    }
  },
  modules: {
    longGrid
  }
}

export default DailySalesDetail



// WEBPACK FOOTER //
// ./src/app/daily_sales/store/DailySalesDetail.js